import React from "react";
import WholeLineContainer from "../../../../../Components/ReportFormTemplate/WholeLineContainer";
import { Divider, Heading } from "@nn-design-system/react-component-library";
import GridContainer from "../../../../../Components/ReportFormTemplate/GridContainer";
import FirstNameField from "./PersonalFields/FirstNameField";
import LastNameField from "./PersonalFields/LastNameField";
import PlaceOfBirthField from "./PersonalFields/PlaceOfBirthField";
import IsForeignerField from "./PersonalFields/IsForeignerField";
import PersonalIDField from "./PersonalFields/PersonalIdField";
import StateOfTaxResidanceField from "./PersonalFields/StateOfTaxResidanceField";
import IsAnotherInsuranceField from "./PersonalFields/IsAnotherInsuranceField";
import NameOfAnotherInsuriensField from "./PersonalFields/NameOfAnotherInsuriensField";
import CitizenshipField from "./PersonalFields/CitizenshipField";
import { useSelector } from "react-redux";
import { StoreType } from "../../../../../redux/store/store";
import IsStudentField from "./PersonalFields/IsStudentField";
import { useDispatch } from "react-redux";
import { updateSecondStepGeneralsNestedFields } from "../../../../../redux/reducers/claimReducer";
import IdentificationDataBlock from "../../../../../Components/IdentificationDataBlock/IdentificationDataBlock";

const PersonalSection: React.FC = ({}) => {
   const dispatch = useDispatch();
    const { reporterRole, isChild } = useSelector(
       (state: StoreType) => state.claimState.reportModel
    );

   const { selectedTypeOfClaims } = useSelector(
      (state: StoreType) => state.claimState
   );

   const isDeathClaim = selectedTypeOfClaims.some((claim) => claim === "death");
    const authStatus = useSelector(
       (state: StoreType) => state.authState.userAuthenticationStatus
    );
    const personModel = useSelector((state: StoreType) => state.claimState.personModel);
    const claimFieldErrorsMessages = useSelector(
       (state: StoreType) => state.claimFieldErrorsState
    );

   return (
      <GridContainer>
         <WholeLineContainer>
            <>
               <Heading
                  variant={"Medium"}
                  hasMargin={false}
                  mb=".5rem"
                  mt="1rem"
               >
                  {isDeathClaim
                     ? "Osobní údaje zesnulé osoby"
                     : "Osobní údaje pojištěné osoby"
                  }
               </Heading>
               <Divider variant="Brand"></Divider>
            </>
         </WholeLineContainer>
         <FirstNameField />
         <LastNameField />
         <PlaceOfBirthField />

         <PersonalIDField />
         <IsForeignerField />
         <CitizenshipField />
         <StateOfTaxResidanceField />
         <IsAnotherInsuranceField />
         <NameOfAnotherInsuriensField />
          <IsStudentField />
          {authStatus === "agent" &&
             !isDeathClaim &&
             !isChild &&
             reporterRole === 0 && (
                <IdentificationDataBlock
                   checked={personModel.performAmlIdentification}
                   identityCardType={personModel.identityCardType}
                   identityCardNumber={personModel.identityCardNumber}
                   identityCardIssuedBy={personModel.identityCardIssuedBy}
                   identityCardValidUntil={personModel.identityCardValidUntil}
                   updateField={(field, value) =>
                      dispatch(
                         updateSecondStepGeneralsNestedFields({
                            field:
                               field === "checked"
                                  ? "performAmlIdentification"
                                  : field,
                            value,
                         })
                      )
                   }
                   validationKeys={{
                      identityCardType: "IdentityCardType",
                      identityCardNumber: "IdentityCardNumber",
                      identityCardIssuedBy: "IdentityCardIssuedBy",
                      identityCardValidUntil: "IdentityCardValidUntil",
                   }}
                   helperText="Pokud očekávaná výše pojistného plnění přesahuje 25 000 Kč, vyplňte prosím část „Doplnit identifikační údaje“ podle platného průkazu totožnosti klienta."
                   fieldErrors={claimFieldErrorsMessages}
                />
             )}
       </GridContainer>
   );
};

export default PersonalSection;
